import React from "react";
import PropTypes from "prop-types";

import Input from "./Input";
import Select from "./Select";

const InputWithDropdown = ({ selectProps, inputProps }) => {
  return (
    <div className="group-items">
      <Select {...selectProps} />
      <div>
        <Input {...inputProps} />
      </div>
    </div>
  );
};

InputWithDropdown.propTypes = {
  selectProps: PropTypes.object.isRequired,
  inputProps: PropTypes.object.isRequired,
};

InputWithDropdown.defaultProps = {
  selectProps: {},
  inputProps: {},
};

export default InputWithDropdown;
